import { Component, OnInit } from '@angular/core';
import { IssuerAPIService } from '../services/issuer-api.service';
import { IssuerBrowseBulletinBoard } from '../Models/Issuer-Browse-Bulletin-Board';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function PDFWelcomeMessage(eventId): any;
declare function responsiveVoiceSpeak_BulletinBoardDoc(title, innerText): any;
declare function responsiveVoiceSpeak(title, innerText): any;
declare var $: any;
declare function FontSizeSettings(): any;
declare function btnToggleNew(): any;

@Component({
  selector: 'app-mydac',
  templateUrl: './mydac.component.html',
  styleUrls: ['./mydac.component.css']
})
export class MydacComponent implements OnInit {

  public IS1: number;
  public issueDoclist: IssuerBrowseBulletinBoard;
  //IssuerBrowseBulletinBoard;    
  tabIndex: number;
  commontabIndex: number;
  constructor(private IssuerAPIService: IssuerAPIService, private router: Router) {
    this.tabIndex = 22;
    this.commontabIndex = 23;
    //remove pagination value local storage
    localStorage.removeItem("Page_Navigation")
  }

  //to get list of IssueBulletinBoard

  GetIssueBulletinBoard() {
    debugger;
    $("#hdbulletin").val(0);
   
    responsiveVoiceSpeak("", "Please wait while the page is loading.");
    document.getElementById("overlay").style.display = "block";
    this.IssuerAPIService.GetIssuerBrowseBulletinBoard().subscribe(data => {
      debugger;
      $("#hdbulletin").val(data['length']);
      document.getElementById("overlay").style.display = "none";
      if (data['length'] > 0) {
        this.issueDoclist = data;
        this.commontabIndex = this.tabIndex + data['length'];

      }
      else {
        this.commontabIndex = 23;

      }
      //else { document.getElementById("pagingDiv").style.display = "none"; }
    }
      ,
      error => {
        if (error.status === 403) {
          this.RemoveLocalStorage();
          document.getElementById("overlay").style.display = "none";
          this.router.navigate(['/login']);
          
        }
        });


  }

  // check local storage 
  CheckLocalStorage(): boolean {
    if (localStorage.getItem("User_Name")) {
      return true;

    }
    else {
      return false;
    }

  }

  // remove local storage
  RemoveLocalStorage() {
    localStorage.removeItem("User_Name");
    localStorage.removeItem("Last_Login")
    localStorage.removeItem("IsSelect_Obligor")
  }


  onKeyUp(event: any, dclink: string) {

    debugger;

    // added for skip button to compliance toolkit
    if (event.target.id == "skipCompliance" && event.keyCode == 9) {
      responsiveVoiceSpeak(event.target.title, " Skip to compliance toolkit. Press enter to skip to compliance toolkit or use tab to go to the bulletin board.");
      // document.getElementById("tblArchiveDocument").focus();
      return;
    }
    // added for skip button to back
    if (event.target.id == "skipCompliance" && event.keyCode == 16) {
      responsiveVoiceSpeak(event.target.title, " Skip to compliance toolkit. Press enter to skip to compliance toolkit or use tab to go to the bulletin board.");
      document.getElementById("skipCompliance").focus();
      return;
    }
    //same here back
    if (event.target.id == "bulletinboard" && event.keyCode == 16) {
      responsiveVoiceSpeak(event.target.title, " Skip to compliance toolkit. Press enter to skip to compliance toolkit or use tab to go to the bulletin board.");
      document.getElementById("skipCompliance").focus();
      return;
    }

    // click on enter key on skiptocomliance toolkit button to go to compliance view toolkit
    if (event.target.id == "skipCompliance" && event.keyCode == 13) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("viewcompliance").innerText, "viewcompliance", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("viewcompliance").focus();
      return;
    }


    if (event.target.id == "viewcompliance" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("viewcompliance").innerText, "viewcompliance", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      // document.getElementById("tblArchiveDocument").focus();
      return;
    }

    if (event.target.id == "viewaccount" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("viewaccount").innerText, "viewaccount", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      // document.getElementById("tblArchiveDocument").focus();
      return;
    }

    if (event.target.id == "filedocument" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("filedocument").innerText, "filedocument", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      // document.getElementById("tblArchiveDocument").focus();
      return;
    }


    if (event.target.id == "lblmydac" && event.keyCode == 9) {
      btnToggleNew();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblmydac").innerText, "lblmydac", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }


    if (event.target.id == "skipCompliance" && event.keyCode == 9) {
      btnToggleNew();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("skipCompliance").innerText, "skipCompliance", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }

    if (event.target.id == "bulletinboard" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("bulletinboard").innerText, "bulletinboard", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }


    if (event.target.id == "viewhistory" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("viewhistory").innerText, "viewhistory", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      // document.getElementById("tblArchiveDocument").focus();
      return;
    }

    if (event.target.id == "continuingeducation" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("continuingeducation").innerText, "continuingeducation", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      // document.getElementById("tblArchiveDocument").focus();
      return;
    }

    if (event.target.id == "searchsystem" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("searchsystem").innerText, "searchsystem", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      // document.getElementById("tblArchiveDocument").focus();
      return;
    }

    if (event.keyCode == 27) {
      //if (event.target.id == "tdAlerts" || event.target.id == "tdobligorDesc" || event.target.id == "tdwebcasts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      //}
      return;
    }

    //if (event.target.id == "bulletIdanchor" && event.keyCode == 13) {
    //  return;
    //}

    if (event.target.id == "lblmydac" && event.keyCode == 13) {
      return;
    }
    //if (event.target.id == "bulletId_1" && event.keyCode == 9) {
    //  BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("bulletId_1").innerText, "bulletId_1", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
    //  // document.getElementById("tblArchiveDocument").focus();
    //  return;
    //}

    if (event.keyCode == 9) {

      if (event.target.title == "bulled") {
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById(event.target.id).innerText, "bulletId_1", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      else {
        responsiveVoiceSpeak(event.target.title, event.target.innerText);
      }
    }

    // enter key code 
    if (event.keyCode == 13) {

      if (event.target.title == "bulled") {
        this.onOpenBulletinBoardDoc(event, dclink);
        //responsiveVoiceSpeak_BulletinBoardDoc("", event.target.innerText);
      }
      else {
        responsiveVoiceSpeak(event.target.title, event.target.innerText);
      }
    }


    if (event.target.id == "bulletinboard" && event.keyCode == 13) {
      document.getElementById("bulletinboard").click();
      return;
    }
    if (event.target.id == "viewcompliance" && event.keyCode == 13) {
      this.onCheckObligor_Redirect_Compliance_Review(event);
      return;
    }
    if (event.target.id == "viewaccount" && event.keyCode == 13) {
      document.getElementById("viewaccount").click();
      return;
    }
    if (event.target.id == "filedocument" && event.keyCode == 13) {
      document.getElementById("filedocument").click();
      return;
    }
    if (event.target.id == "viewhistory" && event.keyCode == 13) {
      this.onCheckObligor_Redirect_ArchivedDocument(event);
      //document.getElementById("viewhistory").click();
      return;
    }
    if (event.target.id == "continuingeducation" && event.keyCode == 13) {
      this.onCheckObligor_Redirect_ContinueEducation(event);
      return;
    }
    if (event.target.id == "searchsystem" && event.keyCode == 13) {
      this.onCheckObligor_Redirect_SearchSyatem(event);
      document.getElementById("searchsystem").click();
      return;
    }

  };

  ngOnInit() {
    
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    this.GetIssueBulletinBoard();
    this.MagnifieronDynamicChecking();
    responsiveVoiceSpeak("", "Welcome to My dac page. You have access to list of Bulletin Board items on the left and links to access your account, Compliance tool kit, Document history and Webinars on the right.Please use tab to go to the next field.");
    localStorage.removeItem("PPC");
  }

  // open document 
  onOpenBulletinBoardDoc(event, documentLink: string): void {

    // if (event.keyCode == 13) {
    var w = 1000;
    var h = 800;
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    responsiveVoiceSpeak("", "The document is now available to be read. To read the document, un-mute your installed screen reader. You need to again mute the screen reader once you have read the document. Use Alt and F4 to close the document.");
    window.open(documentLink + "&inline=1", "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

  }
  //onOpenBulletinBoardDoc(event, file): void {
  //  debugger;
  //  // if (event.keyCode == 13) {
  //    var w = 1000;
  //    var h = 800;
  //    var left = (screen.width / 2) - (w / 2);
  //    var top = (screen.height / 2) - (h / 2);
  //    responsiveVoiceSpeak("", "The document is now available to be read. To read the document, un-mute your installed screen reader. You need to again mute the screen reader once you have read the document. Use Alt and F4 to close the document.");
  //    window.open(file.documentLink +"&inline=1", "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

  //}

  //clik ffrom compliance Review link
  onCheckObligor_Redirect_Compliance_Review(event: any) {
    if (localStorage.getItem("OBLIGOR_ID")) {
      this.router.navigate(['/compliance-review']);
    }
    else {
      localStorage.setItem("Page_Navigation", "CR");
      this.router.navigate(['/reviewtoolkit']);

    }

  }

  // skip to compliance toolkit click function
  SkipComplianceToolKit(event: any): void {
    BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("viewcompliance").innerText, "viewcompliance", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
    document.getElementById("viewcompliance").focus();
  }

  // click on archive document link
  onCheckObligor_Redirect_ArchivedDocument(event: any) {
    if (localStorage.getItem("OBLIGOR_ID")) {
      this.router.navigate(['/archivedcurrentdocuments']);
    }
    else {
      localStorage.setItem("Page_Navigation", "AD");
      this.router.navigate(['/reviewtoolkit']);
    }

  }
  // click on continue education link
  onCheckObligor_Redirect_ContinueEducation(event: any) {
    if (localStorage.getItem("OBLIGOR_ID")) {
      this.router.navigate(['/continuingeducation']);
    }
    else {
      localStorage.setItem("Page_Navigation", "CA");
      this.router.navigate(['/reviewtoolkit']);
    }

  }

  // click on search system link
  onCheckObligor_Redirect_SearchSyatem(event: any) {
    if (localStorage.getItem("OBLIGOR_ID")) {
      this.router.navigate(['/browse-obligor']);
    }
    else {
      localStorage.setItem("Page_Navigation", "BO");
      this.router.navigate(['/reviewtoolkit']);
    }

  }

  onKeyUpDocument(event: any, file) {
    debugger;
    if (event.keyCode == 13) {
      var w = 1000;
      var h = 800;
      var left = (screen.width / 2) - (w / 2);
      var top = (screen.height / 2) - (h / 2);
      window.open(file.documentLink, "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      PDFWelcomeMessage("");
      //documentTabIndex = tabindex;
    }

  }


  //Enable disabled magnifier 
  MagnifieronDynamicChecking() {
    FontSizeSettings();
  }


}


